// import React from "react";
// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";

// const PrivacyPage = () => {
//   return (
//     <div className="min-h-screen bg-gradient-to-b from-[#CBCECE] to-[#77D8EE]">
//       <Navbar />

//       <div className="pt-32 pb-16 px-4 max-w-4xl mx-auto">
//         <div className="bg-white rounded-lg shadow-lg p-8">
//           <h1 className="text-4xl font-bold text-gray-800 mb-4 text-center">
//             Privacy Policy
//           </h1>
//           <p className="text-center text-gray-600 mb-8">
//             LAST REVISED: August 11th, 2025
//           </p>

//           <div className="text-gray-700 space-y-6">
//             <section>
//               <p className="text-gray-600 leading-relaxed mb-6">
//                 <strong>
//                   Plutonic, Inc. ("Plutonic," "we," "our," or "us")
//                 </strong>{" "}
//                 values the privacy of those who visit our website, use our
//                 online platform, or receive our in-person therapy services
//                 (collectively, the "Services"). We take your privacy seriously
//                 and are committed to protecting the personal and health
//                 information we collect from and about you.
//               </p>
//               <p className="text-gray-600 leading-relaxed mb-6">
//                 This Privacy Policy describes:
//               </p>
//               <ul className="text-gray-600 list-disc list-inside space-y-2 ml-4 mb-6">
//                 <li>What personal information we collect</li>
//                 <li>How and why we use your information</li>
//                 <li>How we protect your information</li>
//                 <li>To whom your information may be disclosed</li>
//                 <li>Your rights regarding your information</li>
//                 <li>How to provide or withdraw consent</li>
//               </ul>
//               <p className="text-gray-600 leading-relaxed mb-8">
//                 <strong>
//                   By using our Services, whether online or in person, you
//                   consent to the practices described in this Privacy Policy. If
//                   you do not agree, you must discontinue use of the Services.
//                 </strong>
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 1. Scope of This Privacy Policy
//               </h2>
//               <p className="text-gray-600 leading-relaxed">
//                 This Privacy Policy applies to all Services offered by Plutonic,
//                 whether delivered through our website at
//                 https://www.plutonic.co, our virtual therapy platform, or in
//                 person at one of our physical office locations. All personal and
//                 health information collected in connection with these services
//                 is subject to the protections described in this Privacy Policy.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 2. Types of Information We Collect
//               </h2>
//               <p className="text-gray-600 leading-relaxed mb-4">
//                 We collect two main categories of information:
//               </p>
//               <h3 className="text-xl font-medium text-gray-700 mb-3">
//                 a. Personal Information
//               </h3>
//               <p className="text-gray-600 leading-relaxed mb-4">
//                 Information that identifies you or could reasonably be used to
//                 identify you, such as your name, address, email address, phone
//                 number, and payment details.
//               </p>
//               <h3 className="text-xl font-medium text-gray-700 mb-3">
//                 b. Protected Health Information (PHI)
//               </h3>
//               <p className="text-gray-600 leading-relaxed">
//                 If you engage in therapy services with Plutonic, whether in
//                 person or online, we may collect and store Protected Health
//                 Information ("PHI") as defined by the Health Insurance
//                 Portability and Accountability Act of 1996 ("HIPAA"). This
//                 includes information you provide during intake, assessments,
//                 therapy sessions, and follow-up communications.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 3. How We Collect Information
//               </h2>
//               <p className="text-gray-600 leading-relaxed mb-4">
//                 We may collect information in the following ways:
//               </p>
//               <ul className="text-gray-600 list-disc list-inside space-y-2 ml-4 mb-4">
//                 <li>
//                   Directly from you: When you create an account, schedule
//                   appointments, complete intake forms, or participate in therapy
//                   sessions.
//                 </li>
//                 <li>
//                   Automatically: Through cookies, analytics tools, and similar
//                   technologies when you visit our website.
//                 </li>
//                 <li>
//                   From third parties: Such as your insurance provider (if
//                   applicable), referral sources, or integrated service providers
//                   (e.g., HIPAA-compliant EHR systems).
//                 </li>
//               </ul>
//               <p className="text-gray-600 leading-relaxed">
//                 If you are under 13 years old, we will only collect your
//                 information with verifiable parental consent as required by the
//                 Children's Online Privacy Protection Act ("COPPA").
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 4. How We Use Your Information
//               </h2>
//               <p className="text-gray-600 leading-relaxed mb-4">
//                 We use your personal and health information to:
//               </p>
//               <ul className="text-gray-600 list-disc list-inside space-y-2 ml-4 mb-4">
//                 <li>Provide, manage, and improve our therapy services</li>
//                 <li>Communicate with you about appointments and services</li>
//                 <li>Process payments and insurance claims (if applicable)</li>
//                 <li>
//                   Comply with legal, regulatory, and licensing requirements
//                 </li>
//                 <li>
//                   Ensure the safety, security, and quality of our Services
//                 </li>
//               </ul>
//               <p className="text-gray-600 leading-relaxed">
//                 We will not sell or rent your personal information.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 5. How We Protect Your Information
//               </h2>
//               <p className="text-gray-600 leading-relaxed mb-4">
//                 We use industry-standard safeguards to protect your personal and
//                 health information, including:
//               </p>
//               <ul className="text-gray-600 list-disc list-inside space-y-2 ml-4 mb-4">
//                 <li>
//                   Secure, HIPAA-compliant electronic health record (EHR) systems
//                   for all client records
//                 </li>
//                 <li>Encryption of data in transit and at rest</li>
//                 <li>
//                   Access controls limiting PHI access to authorized personnel
//                   only
//                 </li>
//                 <li>
//                   Confidentiality agreements for all employees, contractors, and
//                   providers
//                 </li>
//               </ul>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 6. Sharing and Disclosure of Information
//               </h2>
//               <p className="text-gray-600 leading-relaxed mb-4">
//                 We may share your information in the following situations:
//               </p>
//               <ul className="text-gray-600 list-disc list-inside space-y-2 ml-4 mb-4">
//                 <li>
//                   <strong>With your consent:</strong> For example, sharing
//                   records with another provider at your request.
//                 </li>
//                 <li>
//                   <strong>With service providers:</strong> Third-party vendors
//                   who perform services for us (e.g., telehealth platform,
//                   billing services, EHR) under HIPAA-compliant agreements.
//                 </li>
//                 <li>
//                   <strong>For legal compliance:</strong> When required by law,
//                   court order, or regulatory authority.
//                 </li>
//                 <li>
//                   <strong>For safety reasons:</strong> If necessary to prevent
//                   or lessen a serious threat to health or safety.
//                 </li>
//                 <li>
//                   <strong>In a business transfer:</strong> If Plutonic is
//                   involved in a merger, acquisition, or sale of assets.
//                 </li>
//               </ul>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 7. Special Provisions for Clients Under 18
//               </h2>
//               <ul className="text-gray-600 list-disc list-inside space-y-2 ml-4">
//                 <li>
//                   <strong>Under 18:</strong> Parental or guardian consent is
//                   required for therapy services.
//                 </li>
//                 <li>
//                   <strong>Under 13:</strong> We comply with COPPA and require
//                   verifiable parental consent before collecting, storing, or
//                   using any personal information.
//                 </li>
//                 <li>
//                   We may require the consenting parent or guardian to
//                   participate in the intake process and provide proof of
//                   identity.
//                 </li>
//                 <li>If consent is withdrawn, services will be discontinued.</li>
//               </ul>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 8. Breach Notification
//               </h2>
//               <p className="text-gray-600 leading-relaxed">
//                 In the event of a breach of unsecured PHI, Plutonic will notify
//                 affected individuals without unreasonable delay, as required by
//                 HIPAA and applicable state laws. We will also notify the U.S.
//                 Department of Health and Human Services (HHS) and, if
//                 applicable, state regulators.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 9. Your Rights
//               </h2>
//               <p className="text-gray-600 leading-relaxed mb-4">
//                 You have the right to:
//               </p>
//               <ul className="text-gray-600 list-disc list-inside space-y-2 ml-4 mb-4">
//                 <li>
//                   <strong>Access</strong> your health records
//                 </li>
//                 <li>
//                   <strong>Request corrections or amendments</strong> to your
//                   records
//                 </li>
//                 <li>
//                   <strong>Request restrictions</strong> on certain uses or
//                   disclosures of your information
//                 </li>
//                 <li>
//                   <strong>Receive an accounting</strong> of disclosures of your
//                   PHI
//                 </li>
//                 <li>
//                   <strong>Withdraw consent</strong> for certain uses of your
//                   information (subject to legal requirements)
//                 </li>
//               </ul>
//               <p className="text-gray-600 leading-relaxed">
//                 Requests may be made by contacting us at help@plutonic.co.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 10. Data Retention
//               </h2>
//               <p className="text-gray-600 leading-relaxed">
//                 We retain your personal and health information only as long as
//                 necessary to provide services, comply with legal obligations,
//                 and maintain business records, including those required by state
//                 mental health laws.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 11. International Users
//               </h2>
//               <p className="text-gray-600 leading-relaxed">
//                 If you use our Services from outside the United States, your
//                 information may be transferred to and stored in the U.S., where
//                 data protection laws may differ from those in your country.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 12. Changes to This Policy
//               </h2>
//               <p className="text-gray-600 leading-relaxed">
//                 We may update this Privacy Policy at any time. The revised
//                 version will be posted on our website with the effective date.
//                 Continued use of our Services after changes are posted
//                 constitutes acceptance of the updated policy.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//                 13. Contact Us
//               </h2>
//               <p className="text-gray-600 leading-relaxed mb-4">
//                 If you have questions, concerns, or complaints about this
//                 Privacy Policy or our data practices, please contact us:
//               </p>
//               <div className="text-gray-600 ml-4">
//                 <p>
//                   <strong>Plutonic, Inc.</strong>
//                 </p>
//                 <p>3295 River Exchange Drive, Suite 567</p>
//                 <p>Norcross, GA 30092</p>
//                 <p>help@plutonic.co</p>
//               </div>
//             </section>

//             <div className="mt-8 p-4 bg-gray-50 rounded-lg">
//               <p className="text-sm text-gray-500 text-center">
//                 Last updated: August 11th, 2025
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default PrivacyPage;

import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#CBCECE] to-[#77D8EE]">
      <Navbar />

      <div className="pt-32 pb-16 px-4 max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-4 text-center">
            Privacy Policy
          </h1>
          <p className="text-center text-gray-600 mb-8">
            LAST REVISED: August 11th, 2025
          </p>

          <div className="text-gray-700 space-y-6">
            <section>
              <p className="text-gray-700 mb-4">
    Plutonic, Inc. (“Plutonic,” “we,” “our,” or “us”) values the privacy of
    those who visit our websites, use our online platforms, or receive our
    in-person therapy services (collectively, the “Services”). We take your
    privacy seriously and are committed to protecting the personal, health, and
    interaction information we collect from and about you.
  </p>

  <p className="text-gray-700 mb-2">This Privacy Policy describes:</p>

  <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700">
    <li>What personal information we collect</li>
    <li>How and why we use your information</li>
    <li>How we protect your information</li>
    <li>To whom your information may be disclosed</li>
    <li>Your rights regarding your information</li>
    <li>How to provide or withdraw consent</li>
  </ul>

  <p className="mt-4 text-gray-700">
    By using our Services, whether through{" "}
    <a
      href="https://www.plutonic.co"
      className="text-blue-600 hover:underline"
    >
      www.plutonic.co
    </a>
    ,{" "}
    <a
      href="https://www.aiplutonic.co"
      className="text-blue-600 hover:underline"
    >
      www.aiplutonic.co
    </a>
    , our virtual therapy platform, or in person, you consent to the practices
    described in this Privacy Policy. If you do not agree, you must discontinue
    use of the Services.
  </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                1. Scope of This Privacy Policy
              </h2>
              <p className="text-gray-700 mb-2">This Privacy Policy applies to:</p>

  <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700">
    <li>
      Our virtual therapy platform delivered by licensed therapists
      (HIPAA-covered services).
    </li>
    <li>
      Our AI Mental Health Companion wellness tool (non-clinical, not
      HIPAA-covered).
    </li>
    <li>Our websites at www.plutonic.co and www.aiplutonic.co.</li>
    <li>In-person therapy sessions delivered by Plutonic providers.</li>
  </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                2. Types of Information We Collect
              </h2>
              <div className="space-y-4 text-gray-700">
    <div>
      <h3 className="text-lg font-medium text-gray-800 mb-1">
        a. Personal Information
      </h3>
      <p>
        Information that identifies you or could reasonably be used to identify
        you, such as name, email, phone number, and payment details.
      </p>
    </div>

    <div>
      <h3 className="text-lg font-medium text-gray-800 mb-1">
        b. Protected Health Information (PHI)
      </h3>
      <p>
        If you engage in therapy services with a licensed therapist, we may
        collect and store Protected Health Information (“PHI”) as defined by
        HIPAA.
      </p>
    </div>

    <div>
      <h3 className="text-lg font-medium text-gray-800 mb-1">
        c. Interaction Data (AI Companion)
      </h3>
      <p>
        If you use the AI Mental Health Companion, we collect your text/chat
        interactions and activity data. This is not PHI unless you are connected
        with a licensed therapist, in which case your interaction history may be
        shared with your therapist as part of your care.
      </p>
    </div>
  </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                3. How We Collect Information
              </h2>
              <p className="text-gray-700 mb-2">We may collect information:</p>

  <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700">
    <li>
      <strong>Directly from you:</strong> When you create an account, chat with
      the Companion, schedule therapy, or complete forms.
    </li>
    <li>
      <strong>Automatically:</strong> Through cookies, analytics tools, and
      similar technologies.
    </li>
    <li>
      <strong>From third parties:</strong> Such as insurance providers or
      HIPAA-compliant EHR systems (therapy only).
    </li>
  </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                4. How We Use Your Information
              </h2>
              <p className="text-gray-700 mb-2">We use your information to:</p>

  <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700">
    <li>Provide and improve our Services.</li>
    <li>Support therapy sessions and billing (therapy clients only).</li>
    <li>
      Improve AI Companion safety, moderation, and quality (de-identified data
      only).
    </li>
    <li>Communicate with you about your account or appointments.</li>
    <li>Comply with legal and regulatory obligations.</li>
  </ul>

  <p className="mt-4 text-gray-700">We do not sell your information.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                5. How We Protect Your Information
              </h2>
              <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700">
    <li>
      <strong>Therapy Services:</strong> All client records are maintained in
      HIPAA-compliant systems, encrypted in transit and at rest, with access
      limited to authorized personnel.
    </li>
    <li>
      <strong>AI Companion Services:</strong> Conversations are encrypted and
      private. Data may be de-identified and aggregated for quality and safety
      improvements.
    </li>
    <li>
      Confidentiality agreements apply to all employees, contractors, and
      providers.
    </li>
  </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                6. Sharing and Disclosure of Information
              </h2>
              <p className="text-gray-700 mb-2">We may share your information:</p>

  <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700">
    <li>With your consent (e.g., sharing records with another provider).</li>
    <li>With service providers under HIPAA-compliant or security agreements.</li>
    <li>As required by law or court order.</li>
    <li>
      If necessary to prevent or lessen a serious threat to health or safety.
    </li>
    <li>In the event of a merger, acquisition, or sale of assets.</li>
  </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                7. Special Provisions – AI Mental Health Companion
              </h2>
              <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700">
    <li>
      The Companion is for wellness support only. It is not therapy, medical
      advice, or clinical monitoring.
    </li>
    <li>
      Users must be 18 years or older and reside in Georgia, USA at launch.
    </li>
    <li>
      If you are using the Companion on your own, interaction data may be
      de-identified and used to improve moderation, safety, and features.
    </li>
    <li>
      If you are using the Companion with a licensed therapist, your therapist
      may access your interaction history as part of your care, and HIPAA
      applies.
    </li>
    <li>
      The Companion includes crisis safeguards but they are not guaranteed. If
      you express suicidal thoughts or threats of harm, the Companion will
      attempt to pause conversation and provide crisis resources, but it is not
      an emergency service.
    </li>
  </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                8. Breach Notification
              </h2>
              <p className="text-gray-700 leading-relaxed">
                If a breach of unsecured PHI occurs, Plutonic will notify affected individuals, HHS, and regulators as required by law.


              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                9. Your Rights
              </h2>
              <p className="text-gray-700 mb-2">You have the right to:</p>

  <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700">
    <li>Access and correct your records.</li>
    <li>Request restrictions on how your information is used.</li>
    <li>Request deletion of data (subject to legal or regulatory limits).</li>
    <li>Withdraw consent for certain uses.</li>
  </ul>

  <p className="mt-4 text-gray-700">
    Requests can be made at{" "}
    <a
      href="mailto:help@plutonic.co"
      className="text-blue-600 hover:underline"
    >
      help@plutonic.co
    </a>
    .
  </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                10. Data Retention
              </h2>
              <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700">
    <li>Therapy PHI is retained as required by Georgia law and HIPAA.</li>
    <li>
      AI Companion interaction data may be retained for safety, moderation, and
      quality improvement, but de-identified for analysis.
    </li>
  </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                11. International Users
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Our Services are operated in the U.S. If you access them from outside the U.S., your data may be transferred to and stored in the U.S.


              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                12. Changes to This Policy
              </h2>
              <p className="text-gray-700 leading-relaxed">
                We may update this Privacy Policy at any time. Continued use after posting constitutes acceptance.


              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                13. Contact Us
              </h2>
              
              <div className="text-gray-700 space-y-1 ml-1">
    <p><strong>Plutonic, Inc.</strong></p>
    <p>3295 River Exchange Drive, Suite 567</p>
    <p>Norcross, GA 30092</p>
    <p>
      <a
        href="mailto:help@plutonic.co"
        className="text-blue-600 hover:underline"
      >
        help@plutonic.co
      </a>
    </p>
  </div>
            </section>

            <div className="mt-8 p-4 bg-gray-50 rounded-lg">
              <p className="text-sm text-gray-500 text-center">
                Last updated: August 11th, 2025
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPage;
